import { KpiInsightsResponse } from '../../maintenance-dashboard/models/maintenance-dashboard-response.model';

export function combineKpiInsights(kpis: (KpiInsightsResponse | undefined)[]): KpiInsightsResponse {
  let totalValue = 0;
  let previousValue = 0;

  for (const kpi of kpis) {
    if (!kpi) continue;

    totalValue += kpi.totalValue;
    previousValue += getPreviousValue(kpi);
  }

  const percentageChange = previousValue === 0 ? 0 : ((totalValue - previousValue) / previousValue) * 100;

  return { totalValue, percentageChange };
}

function getPreviousValue(kpi: KpiInsightsResponse): number {
  if (kpi.previousValue !== null && kpi.previousValue !== undefined) {
    return kpi.previousValue;
  }

  // Older responses carry only the percentage, which cannot recover a previous total of 0 or a drop to 0
  return kpi.percentageChange > -100 ? kpi.totalValue / (1 + kpi.percentageChange / 100) : 0;
}
